module.exports = __webpack_public_path__ + "static/media/text.2331acb5.svg";